<template>
    <div style="background:#fff;padding-bottom: 30px;margin-bottom: -30px;">
        <div class="topimage">
            <el-image style="width:100%"
                :src="require('@/assets/product/banner' + (this.$i18n.locale == 'zh' ? '' : '_' + this.$i18n.locale) + '.jpg')"></el-image>
        </div>
        <div class="appmain">
            <h3 style="text-align: center;font-size: 30px;font-weight: bold;margin-top: 30px;">
                参数对比
            </h3>
            <div style="margin-top: 30px;">
                <table cellpadding="10px"
                    style="width: 100%;table-layout: fixed;border-color:#E2E2E2;border-collapse: collapse;" border="1">
                    <thead style="position: sticky;top:-1px;">
                        <tr style="text-align: left;background: #F9F9F9;">
                            <th style="height: 200px;">
                                <span style="margin-left: 20px;">{{ $t('productinfo.xuanzexinghao') }}</span>
                            </th>

                            <th v-for="(item, index) in 4" :key="item"
                                :style="{ 'vertical-align': duibilist[index] ? 'top' : '' }">
                                <div style="position: relative;" v-if="duibilist[index]">
                                    <div style="position: absolute;width: 20px;height: 20px;background: #E2E2E2;right: 0px;text-align: center;line-height: 20px;cursor: pointer;"
                                        @click.stop="del(index)">
                                        <i class="el-icon-close"></i>
                                    </div>
                                    <div style="width:100%;background: #fff;margin-bottom:10px; text-align: center;">
                                        <el-image style="width: 150px;height:120px;" fit="cover"
                                            :src="duibilist[index].image"></el-image>
                                    </div>
                                    <div style="text-align: center;line-height: 20px;">
                                        {{ duibilist[index].product_model + ' ' + duibilist[index].product_name }}
                                    </div>
                                    <div
                                        style="text-align: center;font-size: 14px;font-weight: normal;color: rgba(51,51,51,0.6);line-height: 20px;">
                                        {{ duibilist[index].product_feature }}
                                    </div>
                                </div>
                                <div v-if="!duibilist[index]">
                                    <div style="display: flex;">
                                        <div style="margin-left: 10px;">{{ $t('productinfo.fenlei') }}</div>
                                        <el-select size="mini" filterable style="margin-left: 70px;width: 50%;"
                                            v-model="classid" :disabled="duibilist.length > 0" @change="classchange">
                                            <el-option v-for="(item, index) in classList" :key="index"
                                                :value="item.cat_id" :label="item.cat_name"></el-option>
                                        </el-select>
                                    </div>
                                    <div style="display: flex;margin-top: 20px;">
                                        <div style="margin-left: 10px;">{{ $t('productinfo.qingxuanxinghao') }}</div>
                                        <el-select size="mini" filterable style="margin-left: 20px;width: 50%;"
                                            v-model="selectid[index]" @change="selectchange">
                                            <el-option v-for="(item, index) in xilielist" :key="index"
                                                :value="item.product_id"
                                                :label="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? item.product_model + ' ' + item.product_name : item.product_name">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr style="text-align: left;" v-for="(item, index) in parameterItemList" :key="index">
                            <th style="background: #F9F9F9;height: 20px;">
                                <span style="margin-left: 20px;">{{ item.item_title }}</span>
                            </th>
                            <th>
                                <span v-if="duibilist[0]" style="white-space: pre-line;">
                                    {{ getParameteritemvalue(0, item.item_id) }}
                                </span>
                            </th>
                            <th>
                                <span v-if="duibilist[1]" style="white-space: pre-line;"
                                    :style="{ 'color': getParameteritemvalue(1, item.item_id) != getParameteritemvalue(0, item.item_id) ? 'red' : '' }">
                                    {{ getParameteritemvalue(1, item.item_id) }}
                                </span>
                            </th>
                            <th>
                                <span v-if="duibilist[2]" style="white-space: pre-line;"
                                    :style="{ 'color': getParameteritemvalue(2, item.item_id) != getParameteritemvalue(0, item.item_id) ? 'red' : '' }">
                                    {{ getParameteritemvalue(2, item.item_id) }}
                                </span>
                            </th>
                            <th>
                                <span v-if="duibilist[3]" style="white-space: pre-line;"
                                    :style="{ 'color': getParameteritemvalue(3, item.item_id) != getParameteritemvalue(0, item.item_id) ? 'red' : '' }">
                                    {{ getParameteritemvalue(3, item.item_id) }}
                                </span>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import { canshuduibi, productsClass, productsList } from "@/api/api"
    export default {
        data() {
            return {
                duibiProduct: [],
                duibilist: [],
                xilielist: [],
                parameterItemList: [],
                selectid: {},
                classList: [],
                classid: ''
            }
        },
        created() {
            this.getList()
            this.getclass()
        },
        methods: {
            getList() {
                let duibiProduct = JSON.parse(localStorage.getItem("duibiProduct"))
                this.duibiProduct = duibiProduct
                canshuduibi({ duibiProduct: duibiProduct }).then(res => {
                    this.duibilist = res.data.duibilist
                    this.xilielist = res.data.xilielist
                    this.parameterItemList = res.data.parameterItemList
                    this.duibilist.forEach(item => {
                        item.image = process.env.VUE_APP_BASE_API + item.image
                    })
                    this.classid = res.data.parent_id
                })
            },
            getclass() {
                productsClass().then(res => {
                    this.classList = res.data
                })
            },
            getParameteritemvalue(index, item_id) {
                let object = this.duibilist[index].parameterList.find((item => item.item_id == item_id))
                if (object) {
                    return object.para_value
                } else {
                    return '/'
                }
            },
            classchange(value) {
                this.classid = value
                productsList({ cat_id: this.classid, page: 1, limit: 9999 }).then(res => {
                    res.data.list.forEach((item, index) => {
                        item.images = process.env.VUE_APP_BASE_API + item.get_image_list[0].product_img
                    })
                    this.xilielist = res.data.list
                })
            },
            selectchange(value) {
                this.duibiProduct.push(value)
                localStorage.setItem("duibiProduct", JSON.stringify(this.duibiProduct))
                this.getList()
                this.selectid = {}
            },
            del(index) {
                let product_id = this.duibilist[index].product_id
                this.duibiProduct = this.duibiProduct.filter((item) => { return item !== product_id })
                localStorage.setItem("duibiProduct", JSON.stringify(this.duibiProduct))
                this.duibilist.splice(index, 1)
            }
        }
    }
</script>
<style scoped></style>